class Course {
	id = null;
	code = '';
	name = '';
	price = null;
	price_neto = null;
	price_bruto = null;
	department_id = null;
	students_limit = null;
	duration_hours = null;
	duration_days = null;
	offices = [];
	modules = [];
	certificate_id = null;
	testimonial_price = 1.33;
	testimonial_amount = 1;
	prerequisites = '';
	description = '';
	note = '';
	active = true;
	vat_exists = true;

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Course;
